<template>
  <div class="yxtbiz-info-selector">
    <div class="clearfix">
      <div class="yxtbiz-info-selector__wrapper clearfix">

        <yxt-input
          class="pull-left"
          placeholder="请输入资讯标题"
          v-model="params.keyword"
          @keyup.enter.native="getNewsList(1)"
          style="width:240px;"
          searchable
          @search='getNewsList(1)'
        >
        </yxt-input>
      </div>
      <div class="table_wrapper">
        <yxt-table
          ref="news_table"
          row-key="id"
          @selection-change="handleSelectionChange"
          v-loading="loading"
          :data="tableData"
          style="width:100%;"
        >
          <yxt-table-column
            v-if="multiple"
            class-name="table-selection-odd"
            type="selection"
            :show-overflow-tooltip='false'
            width="42"
          >
          </yxt-table-column>
          <yxt-table-column
            prop="title"
            label="资讯标题"
            min-width="200"
          >
          </yxt-table-column>
          <yxt-table-column
            prop="publishTime"
            label="创建时间"
            width="166"
          >
            <template slot-scope="scope">
              <!-- {{formatTime((scope.row.status === 1 ? scope.row.publishTime : ''))}} -->
              {{formatTime( scope.row.publishTime)}}
            </template>
          </yxt-table-column>
          <yxt-table-column
            v-if="!multiple"
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <yxt-button
                @click="choose(scope.row)"
                type="text"
                size="small"
              >{{ scope.row.id === (newsTemp.length ? newsTemp[0].id : '') ? '取消选择': '选择'}}</yxt-button>
            </template>
          </yxt-table-column>
          <div
            slot="empty"
            class="empty_content"
          >暂无数据</div>
        </yxt-table>
        <news-pager
          class="clearfix"
          :pager="paging"
          @searchData="getNewsList"
        ></news-pager>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from './service';
import NewsPager from './newsPager';
import {
  Table,
  TableColumn
} from 'yxt-pc';

export default {
  name: 'YxtbizInfoSelector',
  components: {
    NewsPager,
    YxtTable: Table,
    YxtTableColumn: TableColumn
  },
  props: {
    news: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      params: {
        direction: 'DESC',
        catalogId: '',
        orderby: '',
        status: -1,
        keyword: ''
      },
      tableData: [],
      multipleSelection: [],
      paging: {
        pages: 0,
        pageSize: 10,
        total: 0,
        limit: 0,
        offset: 0
      }
    };
  },
  computed: {
    newsTemp() {
      return this.news.map(item => {
        if (typeof item === 'string') {
          return {
            id: item
          };
        }
        return item;
      });
    }
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    update() {
      if (this.multiple) {
        this.$nextTick(() => {
          if (this.tableData.length > 0 && this.newsTemp.length > 0) {
            this.isSearch = true;
            const ids = this.newsTemp.map(item => {
              return item.id;
            });
            this.tableData.map(item => {
              if (ids.includes(item.id)) {
                this.$refs['news_table'].toggleRowSelection(item, true);
              } else {
                this.$refs['news_table'].toggleRowSelection(item, false);
              }
            });
            this.isSearch = false;
          }
        });
      }
    },
    choose(row) {
      let arr = [];
      if (this.newsTemp.length) {
        if (row.id === this.newsTemp[0].id) {
          arr = [];
        } else {
          arr = [row];
        }
      } else {
        arr = [row];
      }
      this.$emit('update:news', arr);
    },
    formatTime(time) {
      if (time) {
        if (typeof time === 'string') {
          time = time.replace(/-/g, '/');
        }
        const date = new Date(time);
        const y = date.getFullYear();
        const M = date.getMonth() + 1;
        const d = date.getDate();
        const H = date.getHours();
        const m = date.getMinutes();
        // const s = date.getSeconds();
        return `${y}-${this.getTimeNumber(M)}-${this.getTimeNumber(
          d
        )} ${this.getTimeNumber(H)}:${this.getTimeNumber(m)}`;
        // return dayjs(time).format('YYYY-MM-DD HH:mm');
      } else {
        return '/';
      }
    },
    getTimeNumber(value) {
      return value > 9 ? value : '0' + value;
    },
    handleSelectionChange(val) {
      if (!this.isSearch) {
        this.multipleSelection = val;
        if (this.multiple) {
          this.$emit('update:news', val);
        }
      }
    },
    getNewsList(current) {
      this.loading = true;
      let params = {
        ...this.params,
        offset: current
          ? (current - 1) * this.paging.pageSize
          : this.paging.offset,
        limit: this.paging.pageSize
      };
      getNewsList(params)
        .then(res => {
          if (res) {
            this.tableData = res.datas;
            this.paging.pages = res.paging.pages;
            this.paging.offset = res.paging.offset;
            this.paging.total = res.paging.count;
            this.update();
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
